import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles, Dialog, DialogTitle, IconButton,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';

import CloseIcon from '@material-ui/icons/CloseRounded';

import { EditEventStyle } from './EditEvent.style';
import EditEvent from './EditEvent';
import { DialogTop } from '@components/economy/DialogComponens';
import { IEvent } from '@app-types/websocket/event.types';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  creator:number;
}

interface IProps extends WithStyles<typeof EditEventStyle> {
  close:() => void;
  open:boolean;
  event:IEvent|undefined;
}

class EditEventDialog extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);


    this.state = {
      creator:0,
    };
  }

  public render() {

    return (
      <Dialog
        open={ this.props.open}
        onClose={() => this.props.close()}
        classes={{paper:this.props.classes.bigDialog}}
      >
        <DialogTop>
          <DialogTitle>{tn.lang.edit}</DialogTitle>
          <IconButton onClick={() => this.props.close()}>
            <CloseIcon />
          </IconButton>
        </DialogTop>
        <div style={{position:'relative', overflow: 'hidden', display: 'flex'}}>
          {this.props.event !== undefined ?<EditEvent 
              close={() => this.props.close()}
              event={this.props.event}
              onDate={undefined}
            />:<div style={{flex:1}}/>}
        </div>
      </Dialog>
    );
  }
}

function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  return {
    userId,
  };
}

export default connect(mapStateToProps)(withStyles(EditEventStyle)(EditEventDialog));



// WEBPACK FOOTER //
// ./src/components/calendar2/eventdetails/EditEventDialog.tsx